import {Component} from '@angular/core';
import {Router} from "@angular/router";

@Component({
    standalone:true,
    templateUrl: '403.component.html',
    styleUrls: ['./403.component.scss']
})
export class P403Component {

    constructor(private router: Router) {
    }

    redirect() {

        this.router.navigate(['login']);
    }
}
